import * as angular from "angular";
import {IHttpService} from "angular";
import {ApiConfig} from "../../commons/models/api-config.model";

export class GlobalsRequestsService {

  /* @ngInject */
  constructor(private $http: IHttpService, private apiConfig: ApiConfig) {
  }

  // ******************************
  //        Public methods
  // ******************************

  getGlobals() {
    const url = this.apiConfig.baseUrl + `/globals`;
    return new Promise((resolve, reject) => {
      this.$http.get(url)
        .then((response) => {
          resolve(response.data);
        })
        .catch((response) => {
          reject(response.data);
        });
    });
  }

  editGlobal(data) {
    const url = this.apiConfig.baseUrl + `/globals`;
    return new Promise((resolve, reject) => {
      this.$http.post(url, data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((response) => {
          reject(response.data);
        });
    });
  }

}

angular
  .module('bringoz.admin.globals')
  .service('globalsRequestsService', GlobalsRequestsService);
